import Vue from "vue";
import Router from "vue-router";

import Home from "@/view/home/Home";
import Login from "@/view/login/Login";
import ProductDetails from "@/view/goods/ProductDetails";
import Register from "@/view/login/Register";
import changePassword from "@/view/login/changePassword";
import singlePage from "@/components/singlePage";

// 商家
import shopIndex from "@/view/shop/shopIndex";

//我的页面
import UserCenter from "@/view/my/UserCenter";
import UserCenterHome from "@/view/my/components/UserCenterHome";
import MyOrder2 from "@/view/my/components/MyOrder2";
import MyFocus from "@/components/MyFocus";
import DiscountCoupon from "@/components/DiscountCoupon";
import MyWallet from "@/components/MyWallet";
import MyMessage from "@/components/MyMessage";
import AfterSale from "@/view/my/components/AfterSale";

import orders from "@/view/order/orders"; // 订单
import placeOrder from "@/view/order/placeOrder"; //下单
import ShoppingCart from "@/view/cart/ShoppingCart"; //购物车
import OrderDetail from "@/view/order/OrderDetail"; // 订单详情
import Securitysetting from "@/view/my/components/Securitysetting"; //账号与安全
import Personaldata from "@/view/my/components/Personaldata"; //个人资料
import Receivingaddress from "@/view/my/components/Receivingaddress"; //收货地址
import interaction from "@/view/my/components/interaction"; //收货地址
import Myfootprint from "@/view/my/components/Myfootprint"; //足迹
import MyCollection from "@/view/my/components/MyCollection"; //收藏
import Evaluate from "@/view/order/Evaluate"; // 订单评价

import RefundOption from "@/view/afterSale/RefundOption"; //退款选择
import Refund from "@/view/afterSale/Refund"; //退款
import RefundDetail from "@/view/afterSale/RefundDetail"; //退款详情

import Search from "@/view/home/components/searchOk"; //搜索后页面
import TopicDetalis from "@/view/home/components/TopicDetalis"; //专题详情

import briefIntroduction from "@/view/ShortcutBar/briefIntroduction"; //简介
import news from "@/view/ShortcutBar/news"; //消息

Vue.use(Router);

export function resetRouter() {
  // 重置Vue Router
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}
export default new Router({
  // 使用 HTML5 History API，访问路径中不再包含 /#/。
  mode: "history",
  /** 每次页面路由切换后将滚动位置重置到顶部 */
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/",
      name: "Home",
      component: Home,
    },
    {
      path: "/product-details/:id",
      name: "ProductDetails",
      component: ProductDetails,
    },
    {
      path: "/shopIndex/:id",
      name: "shopIndex",
      component: shopIndex,
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
    },
    {
      path: "/register",
      name: "Register",
      component: Register,
    },
    {
      path: "/singlePage",
      name: "singlePage",
      component: singlePage,
    },
    {
      path: "/changePassword",
      name: "changePassword",
      component: changePassword,
    },
    // 下单
    {
      path: "/orders/:order",
      name: "orders",
      component: orders,
    },
    {
      path: "/placeOrder/:order",
      name: "placeOrder",
      component: placeOrder,
    },
    //订单详情
    {
      path: "/OrderDetail/:id",
      name: "OrderDetail",
      component: OrderDetail,
    },
    //订单评价
    {
      path: "/Evaluate/:id",
      name: "Evaluate",
      component: Evaluate,
    },
    //搜索页
    {
      path: "/Search",
      name: "Search",
      component: Search,
    },
    //专题详情
    {
      path: "/TopicDetalis/:id",
      name: "TopicDetalis",
      component: TopicDetalis,
    },
    //退款选择
    {
      path: "/RefundOption/:order",
      name: "RefundOption",
      component: RefundOption,
    },
    //退款详情
    {
      path: "/RefundDetail/:id",
      name: "RefundDetail",
      component: RefundDetail,
    },
    //提交退款
    {
      path: "/Refund/:order/:type",
      name: "Refund",
      component: Refund,
    },
    //简介
    {
      path: "/briefIntroduction/:id",
      name: "briefIntroduction",
      component: briefIntroduction,
    },
    //消息
    {
      path: "/news",
      name: "news",
      component: news,
    },
    {
      path: "/user-center/:type",
      name: "UserCenter",
      component: UserCenter,
      redirect: (to) => {
        // 检查当前是否已经在子路由 `/user-center/user-center-home`
        if (to.path !== "/user-center/user-center-home") {
          return "/user-center/user-center-home";
        }
      },
      children: [
        {
          path: "user-center-home",
          name: "UserCenterHome",
          component: UserCenterHome,
        },
        {
          path: "my-order2",
          name: "MyOrder2",
          component: MyOrder2,
        },
        {
          path: "shopping-cart",
          name: "ShoppingCart",
          component: ShoppingCart,
        },
        // 我的收藏
        {
          path: "myCollection",
          name: "MyCollection",
          component: MyCollection,
        },
        // 我的足迹
        {
          path: "myfootprint",
          name: "Myfootprint",
          component: Myfootprint,
        },
        {
          path: "my-focus",
          name: "MyFocus",
          component: MyFocus,
        },
        {
          path: "my-wallet",
          name: "MyWallet",
          component: MyWallet,
        },
        {
          path: "my-message",
          name: "MyMessage",
          component: MyMessage,
        },
        {
          path: "after-sale",
          name: "AfterSale",
          component: AfterSale,
        },
        {
          path: "security-setting",
          name: "Securitysetting",
          component: Securitysetting,
        },
        {
          path: "personal-data",
          name: "Personaldata",
          component: Personaldata,
        },
        {
          path: "receiving-address",
          name: "Receivingaddress",
          component: Receivingaddress,
        },
        {
          path: "interaction",
          name: "interaction",
          component: interaction,
        },
      ],
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js